export default function omitObjectItem(list, data) {
  const exclude = new Set(list);
  return Object.fromEntries(Object.entries(data).filter(item => !exclude.has(item[0]) && !exclude.has(item[1])));
}
